import * as colors from "styles/colorValues.module.scss";
import * as fonts from "styles/fontValues.module.scss";
export const defaultPlotConfig = {
    editable: false,
    displayModeBar: false,
    responsive: true,
    scrollZoom: true,
    showSendToCloud: false,
    showEditInChartStudio: false,
    showTips: false,
    doubleClick: "reset",
};
export const defaultSpikeConfig = {
    showspikes: true,
    spikemode: "across",
    spikecolor: colors.black,
    spikethickness: 1.1,
    spikedash: "5px",
};
export const defaultTickFont = {
    family: fonts.roboto,
    size: 14,
    color: colors.s900,
};
export const defaultHoverLabel = {
    bgcolor: colors.black,
    font: {
        color: colors.white,
        size: 14,
        family: fonts.roboto,
    },
};
export const defaultGridColor = colors.s400;
export const defaultArrowAnnotationTop = {
    x: 0,
    y: 1,
    xref: "paper",
    yref: "paper",
    showarrow: true,
    xshift: -0.6,
    yshift: 1.8,
    arrowhead: 4,
    arrowsize: 0.5,
    ay: 20,
    ax: 0,
    arrowcolor: colors.s900,
};
export const defaultArrowAnnotationLeft = {
    x: 1,
    y: 0,
    xref: "paper",
    yref: "paper",
    arrowside: "end",
    xanchor: "right",
    yshift: -0.5,
    xshift: 1.8,
    arrowhead: 4,
    arrowsize: 0.5,
    showarrow: true,
    ay: 0,
    arrowcolor: colors.s900,
};
